import { render, staticRenderFns } from "./PotensiDetailMap.vue?vue&type=template&id=056d1f92&scoped=true"
import script from "./PotensiDetailMap.vue?vue&type=script&lang=js"
export * from "./PotensiDetailMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d1f92",
  null
  
)

export default component.exports